import {
  Container,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import { PageTitle, PageSubtitle, BoxTable } from './admin-documents.styles';

const AdminDocuments = () => {
  function createData( id, customerName, loremIpsumDo, loremIpsumDo1, loremIpsumDo2) {
    return { id, customerName, loremIpsumDo, loremIpsumDo1, loremIpsumDo2 };
  }

  const rows = [
    createData(1, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(2, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(3, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(4, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(5, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(6, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
    createData(7, 'Amogus', 'Amogus', 'Amogus', 'Amogus'),
  ];

  return (
    <>
      <Container>
        <PageTitle>My documents: Admin</PageTitle>
        <PageSubtitle>View of my documents</PageSubtitle>
        <BoxTable>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Customer Name</TableCell>
                <TableCell align='left'>Lorem Ipsum Do</TableCell>
                <TableCell align='left'>Lorem Ipsum Do</TableCell>
                <TableCell align='left'>Lorem Ipsum Do</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component='th' scope='row'>
                    {row.customerName}
                  </TableCell>
                  <TableCell align='left'>{row.loremIpsumDo}</TableCell>
                  <TableCell align='left'>{row.loremIpsumDo1}</TableCell>
                  <TableCell align='left'>{row.loremIpsumDo2}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </BoxTable>
      </Container>
    </>
  );
};

export default AdminDocuments;
